import * as angular from "angular";

const events = {
  selectAllCommissions: 'select-all-commissions'
};

angular
  .module('bringoz.admin.commissions')
  .constant('commissionConstants', {
    events: events
  });
